import React, { useEffect, useState } from 'react';
import '../styles/Node.css';
import Loader from '../components/Loader';
import moment from 'moment';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import none from '../images/confirm.png';

const Transactions = ({ user }) => {
    const [transactions, setTransactions] = useState([]);
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [filterType, setFilterType] = useState('all');
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userDoc = await getDoc(doc(db, 'stock', user.uid));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    const fetchedTransactions = (userData.transactions || [])
                        .filter(txn => ['Investments', 'Trading'].includes(txn.account) && txn.stage !== 'active')
                        .sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf());

                    setTransactions(fetchedTransactions);
                    setFilteredTransactions(fetchedTransactions);
                }
            } catch (err) {
                console.error("Error loading transactions:", err);
            } finally {
                setLoading(false);
            }
        };

        if (user && user.uid) {
            fetchData();
        }
    }, [user]);

    const filterTransactions = (type) => {
        setFilterType(type);
        if (type === 'all') {
            setFilteredTransactions(transactions);
        } else {
            setFilteredTransactions(transactions.filter(txn => txn.type === type));
        }
    };

    const closeOverlay = (e) => {
        if (e.target.classList.contains('overlaid')) {
            setSelectedTransaction(null);
        }
    };

    if (loading) return <Loader />;

    
    return (
        <div className="transaction-container">
            {/* <h2 className="transaction-heads">Investment Transactions</h2> */}

            <div className="filter-buttons">
                {['all', 'credit', 'debit'].map(type => (
                    <button
                        key={type}
                        className={`filter-button ${filterType === type ? 'active' : ''}`}
                        onClick={() => filterTransactions(type)}
                    >
                        {type.charAt(0).toUpperCase() + type.slice(1)}
                    </button>
                ))}
            </div>

            <div className="transactions-list">
                {filteredTransactions.length > 0 ? (
                    filteredTransactions.map((txn, i) => (
                        <li key={i} className={`transaction-item ${txn.type}`} onClick={() => setSelectedTransaction(txn)}>
                            <div className="transaction-icon">
                                <i className={`fas fa-${txn.type === 'credit' ? 'circle-plus' : 'circle-minus'}`}></i>
                            </div>
                            <div className="transaction-details">
                                <div className="transaction-description">
                                    {txn.description}
                                    <div className="transaction-date">
                                        {new Date(txn.date).toLocaleDateString()}
                                    </div>
                                </div>
                                <div className="transaction-amount">${txn.amount.toFixed(2)}</div>
                            </div>
                        </li>
                    ))
                ) : (
                    <div className="no-transactions">
                        <img 
                        src={none} 
                        alt="" 
                        className="no-transaction"
                        />
                        <p>No transactions available.</p>
                    </div>
                )}
            </div>

            {selectedTransaction && (
                <div className="overlaid" onClick={closeOverlay}>
                    <div className="details-box show">
                        <div className="details-content">
                            <h2>Transaction Details</h2>
                            <ul className="transaction-info">
                                <li><strong>Description:</strong> {selectedTransaction.description}</li>
                                <li><strong>Amount:</strong> ${selectedTransaction.amount.toFixed(2)}</li>
                                <li><strong>Type:</strong> {selectedTransaction.type}</li>
                                <li><strong>Account:</strong> {selectedTransaction.account}</li>
                                <li><strong>Beneficiary:</strong> {selectedTransaction.beneficiary || 'N/A'}</li>
                                <li><strong>Date:</strong> {new Date(selectedTransaction.date).toLocaleDateString()}</li>
                            </ul>
                            <div className="button-container">
                                <span className="closed">Contact Support</span>
                                <span className="contact-support-button" onClick={() => setSelectedTransaction(null)}>
                                    &times; Close
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Transactions;
